import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth-service';
import { EmployeeService } from '../services/employees/employee-service';
import { UserRole } from '../models/enums';
import { catchError, map, of } from 'rxjs';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {

  const authService = inject(AuthService);
  const employeeService = inject(EmployeeService);
  const router = inject(Router);

  const token = authService.getAccessToken();
  const allowedRoles = route.data?.['roles'] as UserRole[] | undefined;


  if (!token) {
    return router.createUrlTree(['/login']);
  }

  const currentEmployee = employeeService.employee();

  // ✅ If user already loaded
  if (currentEmployee) {
    return checkRole(currentEmployee.role, allowedRoles, router, employeeService);
  }

  // 🔥 Refresh case → load profile first
  return employeeService.loadEmployeeProfile().pipe(
    map(res =>
      checkRole(res.data.role, allowedRoles, router, employeeService)
    ),
    catchError(() =>
      of(router.createUrlTree(['/login']))
    )
  );
};


function checkRole(
  role: UserRole,
  allowedRoles: UserRole[] | undefined,
  router: Router,
  employeeService: EmployeeService
) {

  // If no roles defined → allow any authenticated user
  if (!allowedRoles || allowedRoles.length === 0) {
    return true;
  }

  // If role allowed → allow
  if (allowedRoles.includes(role)) {
    return true;
  }

  // 🔥 Auto redirect to first allowed page
  const firstRoute = employeeService.getFirstAllowedRoute();
  return router.createUrlTree([firstRoute]);
}